import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungChemnitz() {
  return (
    <CityPageTemplate
      city="Chemnitz"
      slug="chemnitz"
      intro="Chemnitz als aufstrebender Industriestandort – jetzt ist der richtige Zeitpunkt für smarten Vermögensaufbau."
      description="Unabhängige & digitale Finanzberatung für Chemnitz: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
